import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BadgeCheck, UserRound } from 'lucide-react';

const base = 'flex flex-col items-center gap-2 rounded-l-xl text-white shadow-lg px-2 py-3 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring))]';
const vertical = { writingMode: 'vertical-rl', transform: 'rotate(180deg)' };

/**
 * Two small vertical tabs stuck to the right edge on mobile only: the employee portal (Espace Easer)
 * and the customer portal (Espace client). Hidden on the portals themselves and in the admin.
 */
export default function EaserTab() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/admin') || pathname.startsWith('/easer') || pathname.startsWith('/client')) return null;
  return (
    <div className="md:hidden fixed right-0 top-1/2 -translate-y-1/2 z-[55] flex flex-col gap-2" data-testid="side-tabs">
      <Link
        to="/client"
        aria-label="Accès client — Espace client"
        data-testid="client-side-tab"
        className={`${base} bg-[hsl(var(--brand-apricot))] active:bg-[hsl(var(--brand-apricot))]/90`}
      >
        <UserRound className="h-4 w-4" />
        <span className="text-[11px] font-semibold tracking-wide" style={vertical}>Espace client</span>
      </Link>
      <Link
        to="/easer"
        aria-label="Accès employé — Espace Easer"
        data-testid="easer-side-tab"
        className={`${base} bg-[hsl(var(--primary))] active:bg-[hsl(var(--primary))]/90`}
      >
        <BadgeCheck className="h-4 w-4" />
        <span className="text-[11px] font-semibold tracking-wide notranslate" translate="no" style={vertical}>Espace Easer</span>
      </Link>
    </div>
  );
}
